import React, { useEffect, lazy, Suspense } from "react"
import * as styles from "./Header.module.scss"
import MobileMenu from "./Navigation/MobileMenu"
import { Link } from "gatsby"
import { useSiteQuery } from "../../../hooks/layout/useSiteQuery"
import { useLink } from "../../../hooks/layout/useLink"
import {
  HeaderProvider,
  useHeaderContext,
} from "../../../hooks/layout/HeaderContext"

import { useIsDesktop } from "../../../hooks/function/useIsDesktop"
import WhatsAppLink from "../../WhatsApp/WhatsAppLink"
import DesktopMenu from "./Navigation/DesktopMenu"

const HeaderContent = () => {
  const { headerLogo, headerItems } = useSiteQuery()
  const { isOpen, setIsOpen, handleLinkClick } = useHeaderContext()
  const isDesktop = useIsDesktop()

  const transformHeaderItems = items => {
    return items.map(item => ({
      type: item.type || "default",
      title: item.title,
      subTitle: item.subTitle,
      slug: item.slug || "",
      svgIcon: item.svgIcon || undefined,
      children: item.headerSections
        ? transformHeaderItems(item.headerSections)
        : [],
    }))
  }

  const menuItems = headerItems ? transformHeaderItems(headerItems) : []

  useEffect(() => {
    const bodyEl = document.body

    if (isOpen) {
      bodyEl.style.overflow = "hidden"
    } else {
      bodyEl.style.overflow = ""
    }

    return () => {
      bodyEl.style.overflow = ""
    }
  }, [isOpen])

  return (
    <header className={`bg-white ${styles.stickyHeader}`}>
      <div className={`${styles.containerWithoutPadding}`}>
        {/* Desktop Menu */}
        <div className={styles.desktopOnly}>
          <DesktopMenu menuItems={menuItems} />
        </div>
        <div className={styles.mobileOnly}>
          <div className={styles.mobileHeaderWrapper}>
            {/* Logo */}
            <div className={styles.logo}>
              <Link to={`${useLink("/")}`} aria-label="Header Logo">
                <img
                  src={headerLogo?.file.url}
                  height={headerLogo?.height}
                  width={headerLogo?.width}
                  loading="eager"
                  alt={headerLogo?.title}
                  className={styles.headerLogo}
                  onClick={handleLinkClick}
                />
              </Link>
            </div>

            {/* Center: WhatsApp */}
            <div className={styles.mobileCenter}>
              <WhatsAppLink
                phoneNumber="919205987106"
                message="Hi, I'm interested in your services."
                loading="eager"
              />
            </div>

            {/* Right: Hamburger */}
            <div className={styles.mobileRight}>
              <button
                onClick={() => setIsOpen(!isOpen)}
                className={`${styles.toggleBtn} ${isOpen ? styles.open : ""}`}
                aria-label={isOpen ? "Close menu" : "Open menu"}
              >
                <svg
                  className={styles.toggle}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d={
                      isOpen
                        ? "M6 18L18 6M6 6l12 12"
                        : "M4 6h16M4 12h16M4 18h16"
                    }
                  />
                </svg>
              </button>
            </div>
          </div>

          {isOpen && <MobileMenu menuItems={menuItems} setIsOpen={setIsOpen} />}
        </div>
      </div>
    </header>
  )
}

const Header = () => (
  <HeaderProvider>
    <HeaderContent />
  </HeaderProvider>
)

export default Header
